import React from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Outlet } from 'react-router-dom'
import { DesignSystemProvider } from '@/design-system'
import { AxiosProvider } from '@/context/Axios'
import '@/design-system/css/variables.css'

const Root = styled(Box)({
  height: '100vh',
  width: '100%',
  overflow: 'hidden',
  backgroundColor: '#0b0a10',
  color: 'var(--ds-night-ink)',
  fontFamily: 'var(--ds-font)',
})

/**
 * Public shared gallery — `/g/:shareId`. No auth gate (mirrors
 * `GuestAlbumLayout`): Axios + design system only, so a signed-out visitor
 * can land here directly. Full-bleed dark shell, same as the authenticated
 * `Studio3DLayout`, since this renders the same Babylon canvas.
 */
export function GuestGalleryLayout() {
  return (
    <AxiosProvider>
      <DesignSystemProvider>
        <Root>
          <Outlet />
        </Root>
      </DesignSystemProvider>
    </AxiosProvider>
  )
}
